export const getReducedPrice = (price: number, characters = 2) => {
  return price.toString().includes('.') ? Number(price.toFixed(characters)) : price;
};
